import {useSelector} from 'react-redux';
import {PAYMENT_SESSION_ID_LENGTH} from '../consts';

export const getCountryCode = state => state.customer?.countryCode || 'en';

export const getTranslations = state => state.commonPageData.localisation.translations;
export const useTranslations = () => useSelector(getTranslations);

export const getGenericError = state => state.commonPageData.genericError;
export const getGenericErrorType = state => state.commonPageData.genericErrorType;

export const getWebRelaunchStyleEnabled = () => true;

export const getCalculation = state => state.commonPageData.calculation;

export const getCsrf = state => state.commonPageData?.csrfToken;

export const isLoggedIn = state => !!state.commonPageData.customer?.id;

export const getLanguageCode = state => state.commonPageData.localisation.language.code;

export const getTracking = state => state.commonPageData?.tracking;

export const getLanguageDisplayName = state => state.commonPageData?.localisation?.language?.displayName;

export const getSendCountries = state => state.commonPageData?.sendCountries;

export const getPlatformData = state => state.commonPageData?.platformData;

export const getCustomer = state => state.commonPageData.customer;

export const getAvailableLanguageCodes = state =>
    state.commonPageData.localisation.availableLanguages.map(language => language.code);

export const getLanguageChooserDisabled = state => state.commonPageData.isLanguageChooserDisabled;

export const getPaymentSessionId = props => props?.match?.params?.sessionId.slice(0, PAYMENT_SESSION_ID_LENGTH) ?? '';

export const getIsWebView = state => Boolean(getPlatformData(state)?.isMobile || state.commonPageData?.isWebView);
